import React from 'react';
import PropTypes from 'prop-types';
import { compose, mapProps } from 'recompose';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import { confirmable, createConfirmation } from 'react-confirm';

function Confirmation({
  okLabel,
  cancelLabel,
  title,
  confirmation,
  show,
  proceed,
  dismiss,
  cancel,
  enableEscape,
}) {
  return (
    <div className="static-modal">
      <Modal show={show} onHide={dismiss} backdrop={enableEscape ? true : 'static'} keyboard={enableEscape}>
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {confirmation}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={cancel}>{cancelLabel}</Button>
          <Button className="button-l" bsStyle="primary" onClick={proceed}>{okLabel}</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

Confirmation.defaultProps = {
  okLabel: 'Ok',
  cancelLabel: 'Avbryt',
  title: 'Bekräfta',
  confirmation: '',
  enableEscape: true,
};

Confirmation.propTypes = {
  okLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  title: PropTypes.string,
  confirmation: PropTypes.string,
  show: PropTypes.bool.isRequired,
  proceed: PropTypes.func.isRequired, // called when ok button is clicked.
  cancel: PropTypes.func.isRequired, // called when cancel button is clicked.
  dismiss: PropTypes.func.isRequired, // called when backdrop is clicked or escaped.
  enableEscape: PropTypes.bool,
};

const confirm = compose(
  createConfirmation,
  confirmable,
  mapProps(({ options, ...props }) => ({
    ...props,
    ...options,
  })),
)(Confirmation);

export default function (confirmation, options = {}) {
  // You can pass whatever you want to the component. These arguments will be your Component's props
  return confirm({ confirmation, options });
}
